/**
 * English SSoT for the outage-reporter banner copy. Mirrored by the `outage.reporter.*`
 * i18n keys, which BOTH surfaces now render (web: outage/map/page.tsx; mobile: outage/
 * index.tsx switched in Phase 3 W1-m-b2). As of that switch this const has no live
 * consumer — kept as the English source-of-record (same posture as DEMO_BANNER_COPY).
 * LISTED FOR THE CHECK: either add a byte-identity test pinning the keys to this const
 * (the DemoBanner pattern) or remove it; not decided here to keep a mobile-keying commit
 * out of shared-ui's public API.
 */
export const OUTAGE_REPORTER_COPY = {
  idle: {
    title: "Power out at your location?",
    submit: "Report Now",
  },
  confirming: {
    submit: "Reporting…",
  },
  submitted: {
    title: "Outage reported — thank you",
    detailPrefix: "Reference",
    detailSuffix: "We’ll notify you when crews are dispatched.",
    dismiss: "Dismiss",
  },
} as const;
